/* eslint-disable */
import { useRef, useState, useEffect, useContext } from "react";
import AuthContext from "../../../../context/AuthProvider";
import axios from "axios";
import Cookies from "js-cookie";
import Page from "../../Page";
import * as Icon from "react-bootstrap-icons";
import logo from "../../../../assets/Vector.svg";
import fb from "../../../../assets/fb.png";
import gp from "../../../../assets/gp.png";
import ln from "../../../../assets/in.png";
import "./Login.css";
import { useNavigate, Link } from "react-router-dom";
import { Icons } from "react-toastify";
import Toast from "../../../assetLibComponents/shared/Toast";
import "react-responsive-carousel/lib/styles/carousel.min.css";

//Redux-imports
import { getLoginContent,resendMailRequest } from "../../../../redux/actions/loginActions";
import { useDispatch, useSelector } from "react-redux";
import { Carousel } from "react-responsive-carousel";
import { Mixpanel } from "../../../../Mixpanel";

const LoginComponent = (props) => {
  const dispatch = useDispatch();

  const authCtx = useContext(AuthContext);
  const userRef = useRef();
  const LOGIN_URL = authCtx.loginUrl;

  const [username, setUsername] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  const [showPassword, setShowPassword] = useState("");
  const [password, setPassword] = useState("");
  const [otpStatus, setOtpStatus] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [show, setShow] = useState(false);
  const [authToken, setAuthToken] = useState("");

  const [loginOption, setLoginOption] = useState(1);
  const [resetPassword, setResetPassword] = useState(false);
  const [success, setSuccess] = useState(false);
  const [resendMail, setResendMail] = useState(false);

  const bgImg =
    "https://images.ctfassets.net/3s5io6mnxfqz/3pFLNqKgNyWiK1bitOJtXz/a2dda1332581395c121c866ea135b738/AdobeStock_192946304.jpeg";

  const loginContent = useSelector((state) => state.login.loginContent);

  const handleSubmit = async (e) => {
    if (username === "" || password === "") {
      return;
    }
    e.preventDefault();
    setButtonLoader(true);
    try {
      const response = await axios.post(LOGIN_URL, {
        username: username,
        password: password,
      });
      if (response?.data?.statusCode === "401") {
        console.log("ERR-401");
        // Toast(response?.data?.message, "E");
        Toast(response?.data?.message, "E");
        setButtonLoader(false);
      }else if (response?.data?.statusCode === "403" && response?.data?.message === "Plesase varify your email." ){
        // console.log(response?.data?.data)
        setResendMail(true);
        setButtonLoader(false);
        localStorage.setItem("resendData", JSON.stringify(response?.data?.data));
      }else if (response?.data?.statusCode === "200") {
        Mixpanel.track('LoggedIn');
        Cookies.set("conditionalLogout", false );        
        authCtx.onLogin(response?.data);
        window.location.reload();
        const randomId = Math.floor(Math.random() * 900000) + 100000; // Generate a random token
        const expiryDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
        Cookies.set("chatid", `backend-${randomId}`, { expires: expiryDate }); // Set the cookie with the random token
        navigate("/internal_ama");
        setButtonLoader(false);
      } else {
        Toast(response?.data?.response, "E");
        setButtonLoader(false);
      }
      Cookies.set("conditionalLogout", false );   
      setUsername("");
      setPassword("");
    } catch (err) {
      setButtonLoader(false);
      console.log("ERR",err);
    }
  };
  const resendData = JSON.parse(localStorage.getItem("resendData"))

  const handleResend = () => {
    dispatch(resendMailRequest(resendData));
  }

  useEffect(() => {
    setAuthToken(authCtx.auth);
  }, [setAuthToken, authCtx.auth, authToken]);

  useEffect(() => {
    dispatch(getLoginContent());
  }, []);

  let navigate = useNavigate();

  const title = props.title;
  useEffect(() => {
    document.title = `Zoi Sign in`;
    window.scrollTo(0, 0);

    // if (!localStorage.getItem("userData")) {
    //   navigate("/");
    // }
  }, [title, navigate]);



  return (
    <div title={props.title} className="mt-4 max-sm:mt-2">
    <div>
        <form action="#" method="POST" className="space-y-6">
        <div>
            <label
            htmlFor="email"
            className="block text-sm font-medium leading-6 text-gray-900"
            >
            Email address
            </label>
            <div className="mt-2">
            <input
                type="email"
                placeholder="Email ID"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                id="email"
                name="email"
                autoComplete="email"
                required
                className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
            />
            </div>
        </div>

        <div>
            <label
            htmlFor="password"
            className="block text-sm font-medium leading-6 text-gray-900"
            >
            Password
            </label>
            <div className="relative mt-2">
            <input
                type={showPassword !== true ? "password":"text"}
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                placeholder="Password"
                onKeyDown={(e) => {
                if (e.key === "Enter" && e.target.value !== "") {
                    handleSubmit(e);
                }
                }}
                id="password"
                name="password"
                autoComplete="current-password"
                required
                className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                          />
            { showPassword === true ? <Icon.Eye onClick={() => { setShowPassword(false); }} className="cursor-pointer absolute text-lg text-[var(--brand-primary)] right-[17px] top-[28%]"/> 
                :
                <Icon.EyeSlash onClick={() => { setShowPassword(true); }} className="cursor-pointer absolute text-lg text-gray-500 right-[17px] top-[28%]" />
            }
            </div>
        </div>

        <div className="flex items-center justify-end">
            <div className="text-sm leading-6">
            <span
                onClick={()=>{navigate("/forgetpassword")}}
                className="cursor-pointer font-semibold text-[var(--brand-primary)] hover:text-[#3EA9BD]"
            >
                Forgot password?
            </span>
            </div>
        </div>
        {resendMail && <div className="flex justify-between">

          <div className="cursor-pointer text-green-500">Verification e-mail has been sent!</div>
          <div onClick={handleResend} className="text-black border-b-2 border-solid font-bold border-black cursor-pointer"> Resend</div>
        </div>}

        <div>
            <button
            onClick={handleSubmit}
            type="submit"
            className="h-[36px] flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
            >
            {buttonLoader ? <div className="login-dual-ring"></div> : 'Submit'}
            </button>
        </div>
                  
        <p className="text-center text-sm text-gray-500">
            Don't have an account?{' '}
            <span onClick={()=>{navigate("/signup")}} className="cursor-pointer font-semibold leading-6 text-[var(--brand-primary)] hover:text-indigo-500">
              Sign up
            </span>
        </p> 
        
        </form>
    </div>
    </div>
  );
};

export default LoginComponent;
